import { SET_DATA_TO_EDIT } from "../../redux/actions/action.types";

export default function setDataToEdit(data: any, stateHandler: any) {
  stateHandler({
    type: SET_DATA_TO_EDIT,
    payload: data,
  });
}
